import {Action, Card, openDeleteDialog, showNotification} from 'platform/components';

import {
  WarrantyProgramListItemResponseBody,
  useDeleteWarrantyProgramMutation,
} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {buildArray, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {formatWarrantyDuration} from '../utils/formatWarrantyDuration';
import {openWarrantyProgramFormDialog} from '../utils/openWarrantyProgramFormDialog';
import {WarrantyProgramDetail} from './WarrantyProgramDetail';

interface WarrantyProgramCardProps extends RequiredTestIdProps {
  program: WarrantyProgramListItemResponseBody;
}

export function WarrantyProgramCard(props: WarrantyProgramCardProps) {
  const [deleteWarrantyProgram] = useDeleteWarrantyProgramMutation();

  const handleDelete = () =>
    openDeleteDialog({
      onConfirm: () =>
        deleteWarrantyProgram({warrantyProgramId: props.program.id})
          .unwrap()
          .then(() => showNotification.success(i18n.t('general.notifications.successfullyDeleted')))
          .catch(handleApiError),
    });

  const actions = buildArray<Action>()
    .add({
      type: 'iconButton',
      icon: 'image/edit',
      onClick: () => openWarrantyProgramFormDialog(props.program.id),
      'data-testid': suffixTestId('edit', props),
    })
    .add({
      type: 'iconButton',
      icon: 'action/delete',
      severity: 'danger',
      onClick: handleDelete,
      'data-testid': suffixTestId('delete', props),
    });

  return (
    <Card
      isExpandable
      isClosedByDefault
      variant="inlineGrey"
      title={props.program.name}
      subtitle={formatWarrantyDuration(props.program.duration)}
      actions={actions}
      data-testid={suffixTestId('card', props)}
    >
      <WarrantyProgramDetail
        warrantyProgramId={props.program.id}
        data-testid={suffixTestId('detail', props)}
      />
    </Card>
  );
}
